import { handleErrorSentry } from "../utils/constants/Error";
import { axiosInstance } from "./Axios";

export async function getVisitCapacity() {
    try {
        const response = await axiosInstance.get(`/api/v1/visits/capacity`)
        return response.data
    } catch (error) {
        handleErrorSentry(error, "tryCatch");
    }
}